import { Component, Input } from '@angular/core';
import { NavController, NavParams, MenuController } from 'ionic-angular';
//Pages
 import { TabsPage } from './../../pages/tabs/tabs';

@Component({
    selector: 'menu-toolbar',
    templateUrl: 'menu-toolbar.component.html'
})
export class MenuToolbarComponent {


    @Input('isCurrentCongress') isCurrentCongress : boolean;

    constructor(private navControler: NavController,
        public navParams: NavParams,
        private menuCtrl: MenuController,) {
    }

    goTo(tabId: number) {
         this.navControler.setRoot(TabsPage, { id: tabId });
    }

    toggleMenu() {
        this.menuCtrl.toggle();
    }
}


// WEBPACK FOOTER //
// ./src/components/menu-toolbar/menu-toolbar.component.ts